import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {Link, useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPIErrorResponseType, ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";
import {miro3dlogo, mirodermlogo, mirodrylogo, mirotractlogo} from "../../assets";
import FooterText from "../../components/footerText";



const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });





  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    setResetToken(obj.get('reset_password_token') || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate("/users/sign_in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string, confirmPassword: string }) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

  return (
      <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
          <div className="container d-flex flex-fill flex-column align-items-center pt-4 pb-4 ps-4 pe-4">
              <div className="card shadow-lg my-3 d-none">
                  <h2 className="text-center m-1">Avanos has transitioned from orthogenrx.aspnprograms.com to harmoknee.support effective September 3rd, 2024</h2>
                  <Link to="/enrollments/new" className="text-center text-link text-decoration-none fs-4 fw-medium"> Click Here To Register </Link>
              </div>
              <div className="row justify-content-center align-items-center flex-fill mb-3">
                  <div className="col-12 col-md-7">
                      <h1 className="login-text">Advanced Solutions for Healing</h1>
                      <h2 className="sub-text">
                          Proprietary Perfusion Decellularization Technology for Rapid Cellular Integration
                      </h2>
                      <div className="row mt-2 mt-sm-5 mt-lg-5 mb-3 mb-sm-0 mt-lg-0 reprise-products">
                          <div className="col-12 col-md-3 mb-3 mb-md-0">
                              <div className="card shadow border-0">
                                  <div className="card-body text-center">
                                      <img src={miro3dlogo} className="img-fluid" alt="Miro 3D Logo"/>
                                  </div>
                              </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3 mb-md-0">
                              <div className="card shadow border-0">
                                  <div className="card-body text-center">
                                      <img src={mirotractlogo} className="img-fluid" alt="Miro Tract Logo"/>
                                  </div>
                              </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3 mb-md-0">
                              <div className="card shadow border-0">
                                  <div className="card-body text-center">
                                      <img src={mirodrylogo} className="img-fluid" alt="Miro Dry Logo"/>
                                  </div>
                              </div>
                          </div>
                          <div className="col-12 col-md-3 mb-3 mb-md-0">
                              <div className="card shadow border-0">
                                  <div className="card-body text-center">
                                      <img src={mirodermlogo} className="img-fluid" alt="Miro Derm Logo"/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="col-12 col-md-1"></div>
                  <div className="col-12 col-md-4">
                      <form className="card shadow-lg" onSubmit={handleSubmit(submitPassword)}>
                          <div className="card-header">
                              <h3 className="m-0">Reset Password</h3>
                          </div>

                          <div className="card-body">
                              <div className="mb-4">
                                  <Controller
                                      name="password"
                                      control={control}
                                      defaultValue=''
                                      render={({ field, fieldState: { error } }) => (
                                          <HubInputField
                                              inputId="password"
                                              isRowBased={false}
                                              isRequired={true}
                                              field={field}
                                              error={error}
                                              inputType="password"
                                              inputPlaceholder="New Password"
                                          />
                                      )}
                                  />
                              </div>
                              <Controller
                                  name="confirmPassword"
                                  control={control}
                                  defaultValue=''
                                  render={({ field, fieldState: { error } }) => (
                                      <HubInputField
                                          inputId="confirmPassword"
                                          isRowBased={false}
                                          isRequired={true}
                                          field={field}
                                          error={error}
                                          inputType="password"
                                          inputPlaceholder="Confirm Password"
                                      />
                                  )}
                              />
                          </div>

                          <div className="card-footer d-flex align-items-center justify-content-between">
                              <button disabled={loading} className="btn btn-primary" type="submit">
                                  <div className="row align-items-center px-1">
                                      {loading ? (
                                          <div className="spinner-border text-light col-3" role="status">
                                              <span className="sr-only"></span>
                                          </div>
                                      ) : null}
                                      <p className="col-auto mb-0"> Reset Password </p>
                                  </div>
                              </button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
          <FooterText footerType="black"/>
    </div>
  );
};

export default HubResetPassword;
